<div class="container">
  <div class="stepwizard table-layout">
    <div
      class="stepwizard-step stepwizard-section col-xs-3"
      *ngIf="!profile"
      [ngClass]="{
        'stepwizard-step__bp_lt-md_show': currentStep === step.CREATE_AN_ACCOUNT,
        'stepwizard-step__bp_lt-md_hidden': currentStep !== step.CREATE_AN_ACCOUNT
      }">
      <div class="current-step step" [class.current-step]="currentStep === step.CREATE_AN_ACCOUNT">
        <div class="stepwizard-image">
          <div class="stepwizard-image-container">
            <div class="step-icon" [class.overlay]="currentStep < step.CREATE_AN_ACCOUNT">
              <img src="assets/icons/i-create-account-dark.svg" alt="Logo" />
            </div>
            <div class="stepwizard-texts">
              <span class="stepwizard-text">{{ 'stepper.create' | translate }}</span>
              <span class="stepwizard-text">{{ 'stepper.account' | translate }}</span>
            </div>
          </div>
          <app-button
            *ngIf="currentStep === step.MY_INTERESTS && !completeInfoButtonClicked && !profile"
            label="stepper.button.complete-profile"
            (click)="onCompleteInfoClicked()"
            type="button"
            className="step-wizard"></app-button>
        </div>
      </div>
      <img
        *ngIf="currentStep === step.CREATE_AN_ACCOUNT && !profile"
        class="triangle2"
        src="assets/images/triangulo2.svg"
        alt="triangle 2" />
    </div>

    <div
      class="stepwizard-step stepwizard-section col-xs-3"
      (click)="onProfile(step.BASIC_INFORMATION)"
      [ngClass]="{
        'complete-button': !completeInfoButtonClicked && !profile,
        'stepwizard-step__bp_lt-md_show': currentStep === step.BASIC_INFORMATION,
        'stepwizard-step__bp_lt-md_hidden': currentStep !== step.BASIC_INFORMATION
      }">
      <div
        [ngClass]="{
          'step step-lt-md current-step_bp_lt-md_and_gt-md':
            currentStep === step.BASIC_INFORMATION && (completeInfoButtonClicked || profile),
          'step current-step_bp_lt-md_and_gt-md': currentStep === step.BASIC_INFORMATION,
        }"
        [class.current-step]="currentStep === step.BASIC_INFORMATION">
        <div class="stepwizard-image">
          <div
            class="stepwizard-image-container stepwizard-image-container__bp_lt-md"
            [class.selected]="currentStep === step.BASIC_INFORMATION && completeInfoButtonClicked">
            <div class="step-icon" [class.overlay]="currentStep < 2">
              <img src="assets/icons/i-user-info-dark.svg" alt="Logo" />
            </div>
            <div class="stepwizard-text-wrapper">
              <span class="stepwizard-text">{{ 'stepper.basic' | translate }}</span>
            </div>
          </div>
          <app-button
            *ngIf="currentStep === step.BASIC_INFORMATION && !completeInfoButtonClicked && !profile"
            label="stepper.button.complete-profile"
            (click)="onCompleteInfoClicked()"
            type="button"
            className="ind-btn--secondary"></app-button>
        </div>
      </div>
      <img
        *ngIf="currentStep === step.BASIC_INFORMATION && !profile"
        class="triangle2 triangle2-md-25"
        src="assets/images/triangulo2.svg"
        alt="triangle 2" />
    </div>

    <div
      class="stepwizard-step stepwizard-section col-xs-3"
      (click)="onProfile(step.MY_DEVICES)"
      [ngClass]="{
        'stepwizard-step__bp_lt-md_show': currentStep === step.MY_DEVICES,
        'stepwizard-step__bp_lt-md_hidden': currentStep !== step.MY_DEVICES
      }">
      <div
        [ngClass]="{
          'step step-lt-md current-step_bp_lt-md_and_gt-md': currentStep === step.MY_DEVICES,
        }"
        [class.current-step]="currentStep === step.MY_DEVICES">
        <div class="stepwizard-image">
          <div
            class="stepwizard-image-container stepwizard-image-container__bp_lt-md"
            [class.selected]="currentStep === step.MY_DEVICES && completeInfoButtonClicked">
            <div class="step-icon" [class.overlay]="currentStep < step.MY_DEVICES">
              <img src="assets/icons/i-my-devices-dark.svg" alt="Logo" />
            </div>
            <div class="stepwizard-text-wrapper">
              <span class="stepwizard-text">{{ 'stepper.device' | translate }}</span>
              <span
                class="stepwizard-text-subtitle"
                *ngIf="currentStep === step.MY_DEVICES && !completeInfoButtonClicked"
                >{{ 'stepper.step3.subtitle' | translate }}</span
              >
              <span
                class="stepwizard-text-subtitle stepwizard-text-subtitle__bp_gt-md_hidden"
                *ngIf="currentStep === step.MY_DEVICES && completeInfoButtonClicked && !profile"
                >{{ 'stepper.step3.subtitle' | translate }}</span
              >
            </div>
          </div>
          <app-button
            *ngIf="currentStep === step.MY_DEVICES && !completeInfoButtonClicked && !profile"
            label="stepper.button.complete-profile"
            (click)="onCompleteInfoClicked()"
            type="button"
            className="step-wizard"></app-button>
        </div>
      </div>
      <img
        *ngIf="currentStep === step.MY_DEVICES && !profile"
        class="triangle2 triangle2-md-50"
        src="assets/images/triangulo2.svg"
        alt="triangle 2" />
    </div>

    <div
      class="stepwizard-step stepwizard-section col-xs-3"
      (click)="onProfile(step.ABOUT_ME)"
      [ngClass]="{
        'stepwizard-step__bp_lt-md_show': currentStep === step.ABOUT_ME,
        'stepwizard-step__bp_lt-md_hidden': currentStep !== step.ABOUT_ME
      }">
      <div
        [ngClass]="{
          'step step-lt-md current-step_bp_lt-md_and_gt-md': currentStep === step.ABOUT_ME,
        }"
        [class.current-step]="currentStep === step.ABOUT_ME">
        <div class="stepwizard-image">
          <div
            class="stepwizard-image-container stepwizard-image-container__bp_lt-md"
            [class.selected]="currentStep === step.ABOUT_ME && completeInfoButtonClicked">
            <div class="step-icon" [class.overlay]="currentStep < 4">
              <img src="assets/icons/i-user-about-me.svg" alt="Logo" />
            </div>
            <div class="stepwizard-text-wrapper">
              <span class="stepwizard-text">{{ 'stepper.about' | translate }}</span>
            </div>
          </div>
          <app-button
            *ngIf="currentStep === step.ABOUT_ME && !completeInfoButtonClicked && !profile"
            label="stepper.button.complete-profile"
            (click)="onCompleteInfoClicked()"
            type="button"
            className="step-wizard"></app-button>
        </div>
      </div>
      <img
        *ngIf="currentStep === step.ABOUT_ME && !profile"
        class="triangle2 triangle2-md-75"
        src="assets/images/triangulo2.svg"
        alt="triangle 2" />
    </div>

    <div
      class="stepwizard-step stepwizard-section col-xs-3"
      (click)="onProfile(step.ACCOUNT_MANAGER)"
      *ngIf="profile"
      [ngClass]="{
        'stepwizard-step__bp_lt-md_show': currentStep === step.ACCOUNT_MANAGER,
        'stepwizard-step__bp_lt-md_hidden': currentStep !== step.ACCOUNT_MANAGER
      }">
      <div
        [ngClass]="{
          'step step-lt-md current-step_bp_lt-md_and_gt-md': currentStep === step.ACCOUNT_MANAGER,
        }"
        [class.current-step]="currentStep === step.ACCOUNT_MANAGER">
        <div class="stepwizard-image">
          <div
            class="stepwizard-image-container stepwizard-image-container__bp_lt-md stepwizard-image-container__step_account-manager"
            [class.selected]="currentStep === step.ACCOUNT_MANAGER && completeInfoButtonClicked">
            <div class="step-icon" [class.overlay]="currentStep < 5">
              <img src="assets/images/i-gestion-cuenta.svg" alt="Logo" />
            </div>
            <div class="stepwizard-text-wrapper">
              <span class="stepwizard-text">{{ 'stepper.manager_account' | translate }}</span>
            </div>
          </div>
          <app-button
            *ngIf="currentStep === step.ACCOUNT_MANAGER && !completeInfoButtonClicked && !profile"
            label="stepper.button.complete-profile"
            (click)="onCompleteInfoClicked()"
            type="button"
            className="step-wizard"></app-button>
        </div>
      </div>
      <img
        *ngIf="currentStep === step.ACCOUNT_MANAGER && !profile"
        class="triangle2 triangle2-md-100"
        src="assets/images/triangulo2.svg"
        alt="triangle 2" />
    </div>

    <div
      class="stepwizard-step stepwizard-section col-xs-3"
      (click)="onProfile(step.MY_INTERESTS)"
      [ngClass]="{
        'stepwizard-step__bp_lt-md_show': currentStep === step.MY_INTERESTS,
        'stepwizard-step__bp_lt-md_hidden': currentStep !== step.MY_INTERESTS
      }">
      <div
        [ngClass]="{
          'step step-lt-md current-step_bp_lt-md_and_gt-md': currentStep === step.MY_INTERESTS,
        }"
        [class.current-step]="currentStep === step.MY_INTERESTS">
        <div class="stepwizard-image">
          <div
            class="stepwizard-image-container stepwizard-image-container__bp_lt-md stepwizard-image-container__step_my-interest"
            [class.selected]="currentStep === step.MY_INTERESTS && completeInfoButtonClicked">
            <div class="step-icon" [class.overlay]="currentStep < step.MY_INTERESTS">
              <img src="assets/icons/i-my-interests.svg" alt="Logo" />
            </div>
            <div class="stepwizard-text-wrapper">
              <span class="stepwizard-text">{{ 'stepper.interest' | translate }}</span>
              <span
                class="stepwizard-text-subtitle"
                *ngIf="currentStep === step.MY_INTERESTS && !completeInfoButtonClicked"
                >{{ 'stepper.step5.subtitle' | translate }}</span
              >
              <span
                class="stepwizard-text-subtitle stepwizard-text-subtitle__bp_gt-md_hidden"
                *ngIf="currentStep === step.MY_INTERESTS && completeInfoButtonClicked && !profile"
                >{{ 'stepper.step5.subtitle' | translate }}</span
              >
            </div>
          </div>
          <app-button
            *ngIf="currentStep === step.MY_INTERESTS && !completeInfoButtonClicked && !profile"
            label="stepper.button.complete-profile"
            (click)="onCompleteInfoClicked()"
            type="button"
            className="step-wizard"></app-button>
        </div>
      </div>
      <img
        *ngIf="currentStep === step.MY_INTERESTS && !profile"
        class="triangle2 triangle2-md-100"
        src="assets/images/triangulo2.svg"
        alt="triangle 2" />
    </div>
  </div>

  <div class="stepwizard" *ngIf="!profile">
    <div class="progress center-block" [ngClass]="{ 'prog-bar': !completeInfoButtonClicked }">
      <div
        class="progress-bar progress-bar-success active"
        role="progressbar"
        aria-valuenow="0"
        aria-valuemin="0"
        aria-valuemax="100"
        [ngClass]="{
          'w-0': currentStep === step.CREATE_AN_ACCOUNT,
          'w-25': currentStep === step.BASIC_INFORMATION,
          'w-50': currentStep === step.MY_DEVICES,
          'w-75': currentStep === step.ABOUT_ME,
          'w-100': currentStep === step.MY_INTERESTS
        }"></div>
    </div>
    <div class="stepwizard-row setup-panel">
      <div class="stepwizard-step col-xs-3">
        <button
          type="button"
          class="btn"
          [ngClass]="{
            'btn-circle': currentStep > step.CREATE_AN_ACCOUNT,
            'btn-circle-small': currentStep === step.CREATE_AN_ACCOUNT,
            'btn-circle-small-empty': currentStep < step.CREATE_AN_ACCOUNT
          }">
          <img
            class="check-image__bp_lt-md_hidden"
            *ngIf="currentStep > step.CREATE_AN_ACCOUNT"
            src="assets/icons/i-check.svg"
            alt="Buttons" />
        </button>
      </div>

      <div
        class="stepwizard-step col-xs-3"
        [ngClass]="{ 'stepper-bar': !completeInfoButtonClicked }">
        <button
          type="button"
          class="btn"
          [ngClass]="{
            'btn-circle': currentStep > step.BASIC_INFORMATION,
            'btn-circle-small': currentStep === step.BASIC_INFORMATION,
            'btn-circle-small-md': currentStep > step.BASIC_INFORMATION,
            'btn-circle-small-empty': currentStep < step.BASIC_INFORMATION
          }">
          <img
            class="check-image__bp_lt-md_hidden"
            *ngIf="currentStep > step.BASIC_INFORMATION"
            src="assets/icons/i-check.svg"
            alt="Buttons" />
        </button>
      </div>

      <div class="stepwizard-step col-xs-3">
        <button
          type="button"
          class="btn"
          [ngClass]="{
            'btn-circle': currentStep > step.MY_DEVICES,
            'btn-circle-small': currentStep === step.MY_DEVICES,
            'btn-circle-small-md': currentStep > step.MY_DEVICES,
            'btn-circle-small-empty': currentStep < step.MY_DEVICES
          }">
          <img
            class="check-image__bp_lt-md_hidden"
            *ngIf="currentStep > step.MY_DEVICES"
            src="assets/icons/i-check.svg"
            alt="Buttons" />
        </button>
      </div>

      <div class="stepwizard-step col-xs-3">
        <button
          type="button"
          class="btn"
          [ngClass]="{
            'btn-circle': currentStep > step.ABOUT_ME,
            'btn-circle-small': currentStep === step.ABOUT_ME,
            'btn-circle-small-md': currentStep > step.ABOUT_ME,
            'btn-circle-small-empty': currentStep < step.ABOUT_ME
          }">
          <img
            class="check-image__bp_lt-md_hidden"
            *ngIf="currentStep > step.ABOUT_ME"
            src="assets/icons/i-check.svg"
            alt="Buttons" />
        </button>
      </div>

      <div class="stepwizard-step col-xs-3">
        <button
          type="button"
          class="btn"
          [ngClass]="{
            'btn-circle': currentStep > step.MY_INTERESTS,
            'btn-circle-small': currentStep === step.MY_INTERESTS,
            'btn-circle-small-md': currentStep > step.MY_INTERESTS,
            'btn-circle-small-empty': currentStep < step.MY_INTERESTS
          }">
          <img
            class="check-image__bp_lt-md_hidden"
            *ngIf="currentStep > step.MY_INTERESTS"
            src="assets/icons/i-check.svg"
            alt="Buttons" />
        </button>
      </div>
    </div>
  </div>
</div>
